import React from "react";
import { Card } from "@/components/ui/card";
import { Instagram, ExternalLink, Hash } from "lucide-react";

export default function HashtagWall({ wall }) {
  if (!wall || wall.enabled === false) return null;
  const posts = (wall.posts || []).filter((p) => p && (p.caption || p.image_url));
  if (posts.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 py-12" data-testid="hashtag-wall">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#E32424] font-bold flex items-center gap-1.5">
            <Hash className="w-3.5 h-3.5" /> Social Wall
          </div>
          <h3 className="font-anton text-4xl md:text-5xl uppercase tracking-tighter text-white mt-2">
            {wall.heading || "Join The Conversation"}
          </h3>
          {wall.subheading && <p className="text-sm text-zinc-400 mt-1">{wall.subheading}</p>}
        </div>
        {wall.hashtag && (
          <span className="font-anton text-2xl uppercase text-[#00A86B] tracking-tight" data-testid="hashtag-tag">
            {wall.hashtag}
          </span>
        )}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {posts.map((p, i) => (
          <Card key={p.id || i} className="overflow-hidden bg-[#11241b] border-white/10 group flex flex-col" data-testid={`hashtag-post-${i}`}>
            {p.image_url && (
              <div className="aspect-square bg-[#060d09] overflow-hidden">
                <img src={p.image_url} alt={p.caption || "post"} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
            )}
            <div className="p-4 flex flex-col gap-2 flex-1">
              <div className="flex items-center gap-2">
                {p.avatar_url ? (
                  <img src={p.avatar_url} alt="" className="w-7 h-7 rounded-full object-cover" />
                ) : (
                  <div className="w-7 h-7 rounded-full bg-[#00A86B]/20 flex items-center justify-center text-[#00A86B] text-xs font-bold">
                    {(p.author || p.handle || "?")[0]?.toUpperCase()}
                  </div>
                )}
                <div className="min-w-0">
                  {p.author && <div className="text-sm text-white font-semibold truncate leading-tight">{p.author}</div>}
                  {p.handle && <div className="text-[11px] text-zinc-500 truncate">{p.handle.startsWith("@") ? p.handle : `@${p.handle}`}</div>}
                </div>
              </div>
              {p.caption && <p className="text-sm text-zinc-300 leading-snug line-clamp-3">{p.caption}</p>}
              {p.permalink && (
                <a href={p.permalink} target="_blank" rel="noreferrer"
                  className="mt-auto inline-flex items-center gap-1.5 text-xs text-[#00A86B] hover:text-white pt-1"
                  data-testid={`hashtag-post-link-${i}`}>
                  <Instagram className="w-3.5 h-3.5" /> View post <ExternalLink className="w-3 h-3" />
                </a>
              )}
            </div>
          </Card>
        ))}
      </div>
    </section>
  );
}
